module.exports = __webpack_public_path__ + "img/99.d7ef01c0.png";